import { render, staticRenderFns } from "./OnboardingGetURL.vue?vue&type=template&id=450668f1&scoped=true&lang=pug"
import script from "./OnboardingGetURL.vue?vue&type=script&lang=ts"
export * from "./OnboardingGetURL.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingGetURL.vue?vue&type=style&index=0&id=450668f1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450668f1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
